import styled from "styled-components";
import { BaseProps, baseStyle } from "../styles";

export const Div = styled.div<BaseProps>`
  ${baseStyle}
`;
